export enum GlassOrderStatus {
  PENDING = "pending",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
  DELIVERED = "delivered"
}

export enum GlassOrderFormMode {
  CREATE = "create",
  EDIT = "edit"
}
